import * as Sentry from '@sentry/react';

// Follows the store, not the Auth0 callback, so sessions restored from storage are identified too.
const syncSentryUser = store => {
	let syncedID;
	const sync = () => {
		const { auth, admins } = store.getState();
		const email = auth.adminSSOProfile?.email;
		const id = admins[email]?.id;
		if (id === syncedID) return;
		syncedID = id;
		Sentry.setUser(id ? { id, email } : null);
	};
	sync();
	return store.subscribe(sync);
};

export default syncSentryUser;
